import { SandboxIcon } from "@minket/brand/icons/sandbox";
import { SendIcon } from "@minket/brand/icons/send";
import { createFileRoute } from "@tanstack/react-router";
import { GhostTable } from "@/components/page/ghost";
import { Page } from "@/components/page/page";
import { ProjectScope } from "@/components/page/scope";
import { TestModeStamp } from "@/components/page/stamp";
import { SendTestAction } from "@/components/sending/actions";
import { GatedAction } from "@/components/sending/available";
import { EmailLedger, ledgerColumns, ledgerWidths } from "@/components/sending/ledger";
import { TestOutcomes } from "@/components/sending/outcomes";
import { useSendVolume } from "@/components/sending/volume";

export const Route = createFileRoute("/sandbox")({
  component: Sandbox,
});

const will = "Each email sent with a test key will be listed here with the events it simulated.";

function Sandbox() {
  const volume = useSendVolume("test");
  return (
    <Page
      title="Test mode"
      specimen
      stamp={<TestModeStamp />}
      trace={volume?.days}
      description={
        <>
          Sent with test keys: rendered and stored, never delivered.
          {volume && volume.total > 0 ? (
            <>
              {" "}
              <span className="type-data whitespace-nowrap text-foreground">
                {volume.total.toLocaleString("en-GB")}
              </span>{" "}
              in the last 30 days.
            </>
          ) : null}
        </>
      }
      action={
        <GatedAction
          list="sandbox"
          pending={{ label: "Simulate a send", icon: SendIcon }}
          permission="emails.send"
          forbidden="Viewers cannot send email"
        >
          {(projectId) => (
            <SendTestAction projectId={projectId} mode="test" label="Simulate a send" />
          )}
        </GatedAction>
      }
    >
      <ProjectScope
        will={will}
        icon={<SandboxIcon size={20} />}
        preview={(busy) => (
          <GhostTable
            columns={ledgerColumns}
            widths={ledgerWidths}
            label="test-mode emails"
            busy={busy}
          />
        )}
      >
        {(project) => (
          <EmailLedger
            projectId={project.id}
            list="sandbox"
            icon={SandboxIcon}
            noun="test-mode emails"
            empty={{
              title: "No test-mode email yet",
              description: (
                <>
                  Send with a <code className="type-data">minket_test_</code> key and the email
                  lands here, every event simulated.
                </>
              ),
              preview: <TestOutcomes />,
            }}
          />
        )}
      </ProjectScope>
    </Page>
  );
}
